import { Swiper } from 'swiper/bundle'

export const baseSwiper = new Swiper('.base-swiper', {
	loop: true,
	spaceBetween: 16,
	slidesPerView: 1,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	pagination: {
		el: '.swiper-custom-pagination',
		dynamicBullets: true
	}
})
